import React from "react";
import styled from "styled-components";
import { Col, Row } from "antd";
import {
  ToolOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { StatCard } from "../shared";
import { device } from "../../lib/breakpoints";

const RepairStatsSection = ({
  activeRepairs,
  scheduledRepairs,
  completedRepairs,
}) => {
  return (
    <StatsSection>
      <Row gutter={[24, 24]}>
        <Col xs={24} sm={12} lg={8}>
          <StatCard
            className="stats-card"
            title="Active Repairs"
            value={activeRepairs.length}
            prefix={
              <ToolOutlined style={{ color: "var(--color-primary)" }} />
            }
            valueStyle={{ color: "var(--color-primary)" }}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <StatCard
            className="stats-card"
            title="Scheduled"
            value={scheduledRepairs.length}
            prefix={<ClockCircleOutlined style={{ color: "#faad14" }} />}
            valueStyle={{ color: "#faad14" }}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <StatCard
            className="stats-card"
            title="Completed"
            value={completedRepairs.length}
            prefix={
              <CheckCircleOutlined style={{ color: "var(--color-accent)" }} />
            }
            valueStyle={{ color: "var(--color-accent)" }}
          />
        </Col>
      </Row>
    </StatsSection>
  );
};

const StatsSection = styled.div`
  margin-bottom: 2rem;
  width: 100%;

  .ant-card {
    --stat-title-size: 0.875rem;
    --stat-value-size: 1.5rem;
    --stat-suffix-size: 1.5rem;
    --stat-icon-size: 1.5rem;
  }

  .ant-statistic {
    text-align: center;
  }

  .ant-statistic-title {
    font-family: var(--font-secondary) !important;
    font-size: var(--stat-title-size) !important;
    line-height: 1.25;
    font-weight: 600 !important;
    color: var(--color-text-light);
    margin-bottom: 0.5rem;
  }

  .ant-statistic-content {
    font-family: var(--font-primary) !important;
    font-size: var(--stat-value-size) !important;
    line-height: 1.1;
    font-weight: 700 !important;
    color: var(--color-text) !important;
  }

  .ant-statistic-content-value,
  .ant-statistic-content-value-int,
  .ant-statistic-content-value-decimal {
    font-size: var(--stat-value-size) !important;
    line-height: 1.1;
    font-weight: 700 !important;
    color: var(--color-text) !important;
  }

  .ant-statistic-content-suffix,
  .ant-statistic-content-prefix {
    font-size: var(--stat-suffix-size) !important;
    font-weight: 700 !important;
    line-height: 1.2;
  }

  .ant-statistic .ant-statistic-content-prefix svg,
  .ant-statistic .ant-statistic-content-prefix .anticon {
    font-size: var(--stat-icon-size) !important;
    width: var(--stat-icon-size) !important;
    height: var(--stat-icon-size) !important;
  }

  .stats-card {
    .ant-statistic-title {
      font-size: var(--stat-title-size) !important;
      font-weight: 600 !important;
    }
    .ant-statistic-content {
      font-size: var(--stat-value-size) !important;
      font-weight: 700 !important;
    }
    .ant-statistic-content-value,
    .ant-statistic-content-value-int,
    .ant-statistic-content-value-decimal {
      font-size: var(--stat-value-size) !important;
      font-weight: 700 !important;
    }
    .ant-statistic-content-suffix,
    .ant-statistic-content-prefix {
      font-size: var(--stat-suffix-size) !important;
      font-weight: 700 !important;
    }
    .ant-statistic-content-prefix svg,
    .ant-statistic-content-prefix .anticon {
      font-size: var(--stat-icon-size) !important;
      width: var(--stat-icon-size) !important;
      height: var(--stat-icon-size) !important;
    }
  }

  @media ${device.mobile} {
    .ant-card {
      --stat-title-size: 0.8rem;
      --stat-value-size: 1.25rem;
      --stat-suffix-size: 1.25rem;
      --stat-icon-size: 1.25rem;
    }
  }
`;

export default RepairStatsSection;
